<template lang="pug">
.input-text-component
    label.input-label-text {{ label }}
    input.input-text(
        :id='id',
        type='text',
        :name='label',
        :placeholder='placeholder',
        :value='value',
        :disabled="disabled"
        :class="touch ? '--error' : '' "
        @input='$emit("input", $event.target.value)'
    )
</template>

<script>
export default {
    name: 'TextInputComponent',
    props: {
        value: {},
        id: {
            type: String,
            default: () => `text-input-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },

        disabled: {
            type: Boolean,
            default: false
        },

        touch: {
            type: Boolean,
            default: false
        },

        placeholder: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
.input-text-component {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
}

.input-text {
    margin: 5px 0 10px 0;
    height: 26px;
    border: 2px solid var(--primary-light-green) !important;
    border-radius: 5px;
}

.input-text.--error {
    border: 2px solid var(--primary-light-red) !important;
}

.input-text:focus-visible {
    border: 2px solid var(--primary-green) !important;
    border-radius: 5px;
    outline: none;
}

.input-text:focus-visible.--error {
    border: 2px solid var(--primary-red) !important;
}
</style>
